const CLOUDINARY_ACCESS_TOKEN_NAME = '__cld_token__'

/** Appends an access token to Cloudinary URLs and leaves other URLs unchanged. */
export const appendCloudinaryAccessToken = (url: string, accessToken: string | undefined): string => {
  if (accessToken === undefined) return url

  try {
    const parsedUrl = new URL(url)
    if (parsedUrl.hostname !== 'res.cloudinary.com') return url

    parsedUrl.searchParams.set(CLOUDINARY_ACCESS_TOKEN_NAME, accessToken)
    return parsedUrl.toString()
  } catch {
    return url
  }
}
